import * as React from 'react';
import './RequestFormWrapper.css';
import { LinkTreeItem, LinkTree } from '../LinkTree';
import { ContainerLayout } from '@emorg-prd/standard-react';
import {Section, ProgressBar} from '../';

interface ExemptionDetailsFormWrapperProps {
	title: string;
	passage?: any;
	linkTree?: LinkTreeItem[];
	loading?: boolean;
	children?: any;
}

const ExemptionDetailsFormWrapper = (props: ExemptionDetailsFormWrapperProps) => {
	
		return (
			<ContainerLayout type="em-l-container" >
				<div className="em-u-margin-top-double em-u-margin-bottom-double">
					{props.linkTree?.length > 0 && !props.loading &&
						<LinkTree links={props.linkTree} />}
					<div id={localStorage.getItem('theme') === 'default' ? 'content' : null}>
						<Section title={props.title} underline={true} className="em-u-padding">
							{!!props.passage &&
								<header className="em-c-section__header">
									{props.passage}
								</header>}
							{props.loading ?
								<ProgressBar
									label='Loading form...'
									className="em-u-margin-top-half"
									indeterminate
									value={0}
								/> :
								<ContainerLayout>
									<div className="content-body">
									{props.children}
									</div>
								</ContainerLayout>}
						</Section>
					</div>
				</div>
			</ContainerLayout>
		);
}

export default ExemptionDetailsFormWrapper;
